function QRCodeIcon({ size = 20, fill = 'none' }: { size?: number; fill?: string }) {
  return (
    <svg
      width={`${size}`}
      height={`${size}`}
      viewBox="0 0 20 20"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8333 17.5V15.8333H12.5V17.5H10.8333ZM9.16667 15.8333V11.6667H10.8333V15.8333H9.16667ZM15.8333 13.3333V10H17.5V13.3333H15.8333ZM14.1667 10V8.33333H15.8333V10H14.1667ZM4.16667 11.6667V10H5.83333V11.6667H4.16667ZM2.5 10V8.33333H4.16667V10H2.5ZM10 4.16667V2.5H11.6667V4.16667H10ZM3.75 6.25H6.25V3.75H3.75V6.25ZM2.5 7.5V2.5H7.5V7.5H2.5ZM3.75 16.25H6.25V13.75H3.75V16.25ZM2.5 17.5V12.5H7.5V17.5H2.5ZM13.75 6.25H16.25V3.75H13.75V6.25ZM12.5 7.5V2.5H17.5V7.5H12.5ZM14.1667 17.5V15H12.5V13.3333H15.8333V15.8333H17.5V17.5H14.1667ZM10.8333 11.6667V10H14.1667V11.6667H10.8333ZM7.5 11.6667V10H5.83333V8.33333H10.8333V10H9.16667V11.6667H7.5ZM8.33333 7.5V4.16667H10V5.83333H11.6667V7.5H8.33333ZM4.375 5.625V4.375H5.625V5.625H4.375ZM4.375 15.625V14.375H5.625V15.625H4.375ZM14.375 5.625V4.375H15.625V5.625H14.375Z"
        fill="#656263"
      />
    </svg>
  );
}

export default QRCodeIcon;
